(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-sgp-cpu-catalog]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.classList.add('is-enhanced');
      const form = root.querySelector('[data-sgp-cpu-form]');
      const shell = root.querySelector('.sgp-cpu-filter-shell');
      const mobile = window.matchMedia('(max-width: 749px)');
      shell.open = !mobile.matches;
      mobile.addEventListener('change', event => { shell.open = !event.matches; });
      root.querySelector('#sgp-cpu-sort').addEventListener('change', () => form.requestSubmit());
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = input.value === ''; });
      });
      const controls = root.querySelector('.sgp-cpu-view');
      controls.hidden = false;
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-sgp-view]');
        if (!button) return;
        root.querySelector('[data-sgp-cpu-items]').classList.toggle('is-grid', button.dataset.sgpView === 'grid');
        controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
